@switch (typeAccess) {
  @case ('1') {
    <app-pdf></app-pdf>
  }
  @case ('2') {
    <app-page-general
      [idPage]="2"
      [quotationId]="quotationId"
      [starNgOnInit]="true"
      [autoSave]="true"
    ></app-page-general>
  }
  @case ('3') {
    <app-page-general
      [idPage]="1"
      [quotationId]="quotationId"
      [starNgOnInit]="true"
      [autoSave]="true"
    ></app-page-general>
  }
}
